// What a refused crew action says on the tablet: the server's reason in Russian (a 409
// code, the missing fields of the call card, the field a 422 rejected and why), or that
// the network is gone; "could not save" only when the server itself failed.

import { App } from 'antd';

import { errorText } from '@/api/errors';

export function useCrewFail() {
  const { message } = App.useApp();
  return (error: unknown) => {
    void message.error(errorText(error));
  };
}
